export default __webpack_public_path__ + "static/Cart-Mobile-f376047fd20541953fed1bf6b9087f3c.jpg";